import React from "react";
import ReportsDateSelect from "../../../commons/ReportsDateSelect/ReportsDateSelect";
import "../index.scss";
import { DropDown } from "../../../commons";
import { BranchListType } from "../../../../screens/Reports/ProfitLoss";

type AppProps = {
  startDate?: any;
  endDate?: any;
  data?: any;
  handleStartDateChange: (date: any) => void;
  handleEndDateChange: (date: any) => void;
  handleSubmitData?: () => void;
  toggle: boolean;
  isDownloadDetailedProfitLossPresent: boolean;
  setToggle: (data: boolean) => void;
  handleDownloadDetailedProfitAndLossStatement: () => void;
  branchSelected: any;
  handleBranchChange: (data: BranchListType) => void;
  branchList: any;
};

const DetailedProfitLossHeader = ({
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
  toggle,
  setToggle,
  branchSelected,
  handleBranchChange,
  data,
  branchList,
  isDownloadDetailedProfitLossPresent,
  handleDownloadDetailedProfitAndLossStatement,
}: AppProps) => {
  return (
    <>
      {/* <div className="grouping-headers mt-3">Detailed Profit & Loss</div> */}
      <div
        className="d-flex position-relative justify-content-start align-items-center mt-3"
        style={{ gap: "0.7rem" }}
      >
        <div className="form-group">
          <label className="mb-1">Date</label>
          <div>
            <ReportsDateSelect
              setToggle={setToggle}
              toggle={toggle}
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
            />
          </div>
        </div>
        <div className="form-group ml-4 mr-4" style={{ width: "15%" }}>
          <label className="mb-1">Branch</label>
          <DropDown
            options={
              branchList
                ? [{ value: "", label: "Select Branch..." }, ...branchList]
                : [{ value: "", label: "Select Branch..." }]
            }
            value={branchSelected}
            handleChange={handleBranchChange}
          />
        </div>
        <div className="mt-2">
          <button
            className="btn btn-primary"
            onClick={handleSubmitData}
            disabled={!startDate?.length || !endDate?.length}
          >
            Get Report
          </button>
        </div>
      </div>
    </>
  );
};

export default DetailedProfitLossHeader;
